import axios from "axios";
import { API_BASE_URL } from "../config/config";

export const initiateIndianPayment = async (service) => {
  const response = await axios.post(`${API_BASE_URL}/initiate-indian-payment`, {
    currency: service.currency,
    careFees: service.careFees,
    userId: service._id,
  });

  return response.data;
};

export const submitIndianPayment = async ({
  serviceId,
  customerId,
  transactionNumber,
  receiptFile,
}) => {
  const formData = new FormData();
  formData.append("serviceId", serviceId);
  formData.append("customerId", customerId);

  if (transactionNumber?.trim()) {
    formData.append("transactionNumber", transactionNumber.trim());
  }

  if (receiptFile) {
    formData.append("receipt", receiptFile);
  }

  const response = await axios.post(
    `${API_BASE_URL}/submit-indian-payment`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response.data;
};
